import moment from 'moment';
import { BaseQuery2 } from '@/utils';
import { CALCWEIGHT, PIECE } from '@/models/GenerateCondit/Interrelated';


/** 获取流向基准*/
export const PlanDepartureBasise = params => {
  return {
    // 查预计表当前站出发到下一站省区
    simpleGranularity: 'all',
    dataSource: 'route_plan_result',
    dimensions: ['nextProvinceArea', 'scanSite', 'nextSite', 'taskNo'], //taskNo 无用
    startDate: params.startDate,
    endDate: params.endDate,
    aggregators: [CALCWEIGHT],      // 聚合无用
    andFilters: [
      { key: 'scanType', value: '分拨发车' },
      { key: 'isDestinationCenter', value: '否' },
    ],
    inFilters: [
      { key: 'scanSite', value: params.scanSite },
    ]
  }
}

/** 根据省区获取下一站 */
export const PlanProvenceGetNext = params => {
  return {
    // 查预计表当前站出发到下一站省区
    simpleGranularity: 'all',
    dataSource: 'route_plan_result',
    dimensions: ['scanSite'],
    startDate: params.startDate,
    endDate: params.endDate,
    // aggregators: [CALCWEIGHT],
    andFilters: [
      { key: 'scanType', value: '分拨发车' },
      { key: 'isDestinationCenter', value: '否' },
      { key: 'scanProvinceArea', value: params.scanProvinceArea },
    ]
  }
}

/**
 * 网名/中转/在库列表
*/
export const PlanDepartureNextSiteQuery = params => {
  return [
    {
      // 网点到达预计 0
      simpleGranularity: 'all',
      dataSource: 'route_plan_result',
      dimensions: ['nextSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨到车' },
        { key: 'isOriginCenter', value: '是' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    {
      // 网点到达实际 1
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite', 'scanSite'],
      startDate: moment(params.startDate).add(0, 'day').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isOriginCenter', value: '是' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    {
      // 中转到达预计 2
      simpleGranularity: 'all',
      dataSource: 'route_plan_result',
      dimensions: ['nextSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'isOriginCenter', value: '否' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨到车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    {
      // 中转到达实际 3
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'isOriginCenter', value: '否' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨卸车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    // #region 在库(库存)查询条件
    {
      // 4  分拨卸车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite', 'scanSite'],
      // startDate: params.startDate, // moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss') ,
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
      // unloadTime
    },
    {
      // 5  分拨装车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['planNextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSites },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
    // #endregion

    // #region 在库(7日库存)查询条件
    // {
    //   // 6  分拨卸车
    //   simpleGranularity: 'all',
    //   dataSource: 'actual_load_unload_result',
    //   dimensions: ['nextSite', 'scanSite'],
    //   startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
    //   endDate: params.endDate,
    //   aggregators: [CALCWEIGHT],
    //   andFilters: [
    //     { key: 'scanType', value: '分拨卸车' },
    //     { key: 'isDestinationCenter', value: '否' },
    //   ],
    //   inFilters: [
    //     { key: 'scanSite', value: params.scanSite },
    //     { key: 'nextSite', value: params.nextSites },
    //   ],
    //   // unloadTime
    // },
    // {
    //   // 7  分拨装车
    //   simpleGranularity: 'all',
    //   dataSource: 'actual_load_unload_result',
    //   dimensions: ['planNextSite', 'scanSite'],
    //   startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
    //   endDate: params.endDate,
    //   aggregators: [CALCWEIGHT],
    //   andFilters: [
    //     { key: 'scanType', value: '分拨装车' },
    //   ],
    //   inFilters: [
    //     { key: 'scanSite', value: params.scanSite },
    //     { key: 'planNextSite', value: params.nextSites },
    //   ],
    //   boundFilters: [
    //     {
    //       "dimension": "unloadAggregateTime",
    //       "lowerValue": moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD'),
    //       "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
    //       "lowerEq": false,
    //       "upperEq": false
    //     }
    //   ],
    // },
    // #endregion
  ]
}

/** 获取出发站到下一站(流向)的任务号 */
export const PlanDepartureNextTaskNoQuery = params => {
  return {
    // 6 获取当前站到下一站所有 taskNo
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    // dimensions: ['scanSite', 'nextSite', 'taskNo'],
    dimensions: ['taskNo'],
    startDate: params.startDate,
    endDate: params.endDate,
    // aggregators: [CALCWEIGHT],  // 聚合无用
    andFilters: [
      { key: 'scanType', value: '分拨装车' },
      { key: 'isDestinationCenter', value: '否' },
    ],
    inFilters: [
      { key: 'scanSite', value: params.scanSite },
      { key: 'nextSite', value: params.nextSites },
    ],
  }
}

/**
 * 已装未发
 * 分拨装车(1) - 根据tms已发出车辆任务号查(0)
 * @scanSite
 * @startDate
 * @endDate
 * @taskNos 任务号集合
 * @siteTaskNos 当前站发往下一站所有taskNo集合
*/
export const actualDepartureQuery = params => {
  return [
    {
      // 已装未发实际
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'taskNo', value: params.taskNos },
      ]
    },
    {
      // 已装未发计划
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite', 'scanSite', 'taskNo'], // , 'taskNo'
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'taskNo', value: params.taskNos_plan },
      ]
    },
  ]
}

/**
 * 网点/中转明细
 */
export const PlanWeightDetialQuery = (params) => {

  return {
    plan: {
      // 网点到达预计 0
      simpleGranularity: 'all',
      dataSource: 'route_plan_result',
      dimensions: ['waybillNo', 'productType', params.dimension],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨到车' },
        { key: 'isOriginCenter', value: params.isOriginCenter },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    actual: {
      // 网点到达实际 1
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'productType', params.dimension],
      startDate: moment(params.startDate).format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isOriginCenter', value: params.isOriginCenter },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    getPlanPreSite: {
      // 预计到的上一站 1
      simpleGranularity: 'all',
      dataSource: 'route_plan_result',
      dimensions: ['waybillNo', params.dimension],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'isOriginCenter', value: params.isOriginCenter },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨到车' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNo }
      ],
    }
  }
}
/**
  库存(装卸)导出明细
 */
export const DesSiteDetailQuery = (params) => {
  return {
    unload: {
      // 卸车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'productType', 'nextSite', 'destinationCenter', 'superiorityProduct'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    load: {
      // 装车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'productType', 'planNextSite', 'destinationCenter', 'superiorityProduct'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNos },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
  }
}

export const DesSiteDetailQuerys = (params) => {
  return {
    unload: {
      // 卸车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'productType', 'nextSite', 'destinationCenter', 'superiorityProduct'],
      startDate: moment(params.startDate).add(params.sotckDayCount, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    load: {
      // 装车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'productType', 'planNextSite', 'destinationCenter', 'superiorityProduct'],
      startDate: moment(params.startDate).add(params.sotckDayCount, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSite },
      ],
      // inFilters: [
      //   { key: 'waybillNo', value: params.waybillNos },
      // ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(params.sotckDayCount, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
  }
}

export const DesSiteDetailQueryss = (params) => {
  return {
    unload: {
      // 卸车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'productType', 'nextSite', 'destinationCenter', 'superiorityProduct'],
      startDate: moment(params.startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(params.endDate).format('YYYY-MM-DD HH:mm:ss'),
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    load: {
      // 装车
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'productType', 'planNextSite', 'destinationCenter', 'superiorityProduct'],
      startDate: moment(params.startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(params.endDate).format('YYYY-MM-DD HH:mm:ss'),
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNos },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
  }
}

/**
 * 库存非/优势产品
 */
export const departuresuPeriorityQuery = params => {
  return {
    unload: {
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'superiorityProduct'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT, PIECE],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    load: {
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_result',
      dimensions: ['waybillNo', 'superiorityProduct'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT, PIECE],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNos },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
  }
}
